import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import BaseOverrideNoHiddenWithRadioGroupPicklist from './FieldKeepSelector/metaOverride';
import FieldLayout from './Field';
import UpdateActionLayout from './FieldKeepSelector';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  fieldPair: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();

  const fieldList = resource.attr('fieldsToUpdate').resources().list().map(((fieldPair) => {
    const scenarioAccountField = fieldPair.attr('oldField').resources().head();
    const appAccountField = fieldPair.attr('newField').resources().head();
    return (
      <Box className={classes.fieldPair} key={`fieldPair-${fieldPair.id()}`}>
        <MetaFormInline
          noIndividualSubmitButtons
          fullWidth
          resource={scenarioAccountField}
          layout={FieldLayout}
          metaOverrideSet={BaseOverrideNoHidden}
        />
        <MetaFormInline
          noIndividualSubmitButtons
          fullWidth
          resource={fieldPair}
          layout={UpdateActionLayout}
          metaOverrideSet={BaseOverrideNoHiddenWithRadioGroupPicklist}
        />
        <MetaFormInline
          noIndividualSubmitButtons
          fullWidth
          resource={appAccountField}
          layout={FieldLayout}
          metaOverrideSet={BaseOverrideNoHidden}
        />
      </Box>
    );
  }));

  return (
    <div
      className={classNames(className, classes.root)}
    >
      <TitleSection />
      {fieldList}
    </div>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
